import { render, staticRenderFns } from "./HowItWorksCard.vue?vue&type=template&id=4f3eb21d"
import script from "./HowItWorksCard.vue?vue&type=script&lang=js"
export * from "./HowItWorksCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports